module.exports = __webpack_public_path__ + "static/img/th-crads-technical2-06.779d89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-technical2-06.png
// module id = 8LuD
// module chunks = 1